import { Navigate, useParams } from 'react-router-dom';

import { useGetCargo } from '@/shared/actions/erp/empleados';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveCargosPage } from '../../shared/saveCargos';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateCargoPageInterface {}

const UpdateCargoPage: React.FC<UpdateCargoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_cargo)

  const { id } = useParams();
  const { data, isLoading } = useGetCargo(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_cargo) return <Navigate to="/nomina/cargos" />;

  return <SaveCargosPage titlePage="Editar Cargos" editCargo={data.data} />;
};

export default UpdateCargoPage;
